module.exports = [{
      plugin: require('/Users/matt/Projekty/InnNEW/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
